import { Categories } from "modules/categories";

const CategoriesPage = () => {
  return <Categories />;
};

export default CategoriesPage;
